import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState } from 'react';
import { Col, Container, Dropdown, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import GoogleImg from '../components/GoogleImg';
import ManPerfectImg from '../components/ManPerfectImg';
import { en, th } from '../Variable';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

export default function SuccessPerfect() {

    let params = useParams();
    const [lang, setLang] = useState<string | undefined | null>('en');

    useEffect(() => {
        const _lang = params.lang;
        if (_lang !== undefined) {
            setLang(_lang?.toString());
        }
    }, [params]);

    return (
        <Container>
            <Row>
                <Col className='dropdown-col' lg={12}>
                    <Dropdown onSelect={(eventKey) => setLang(eventKey)}>
                        <Dropdown.Toggle>
                            <FontAwesomeIcon icon={faGlobe as IconProp} />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item eventKey={'en'} active={lang === 'en'}>EN</Dropdown.Item>
                            <Dropdown.Item eventKey={'th'} active={lang === 'th'}>TH</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </Col>
            </Row>
            <div className="success_perfect">
                <div className="success_perfect__title">
                    <ManPerfectImg />
                    <div>
                        <h1>{lang === 'en' ? en.thankPerfectLabel : th.thankPerfectLabel}</h1>
                        <div className="success_perfect__subtitle">{lang === 'en' ? en.thankPerfectSubLabel : th.thankPerfectSubLabel}</div>
                    </div>
                </div>

                <div className="description">
                    <GoogleImg />
                    <div className="description__text">
                        <p>{lang === 'en' ? en.thankGoogleLabel1 : th.thankGoogleLabel1}</p>
                        <p>{lang === 'en' ? en.thankGoogleLabel2 : th.thankGoogleLabel2}</p>
                    </div>
                    <a href={process.env.REACT_APP_GOOGLE_REVIEW_URL}>Leave review on google</a>
                </div>
            </div>
            <footer>
                <div className="footer-info">
                    <div className="footer-info__info">{lang === 'en' ? en.inquiriesLabel : th.inquiriesLabel}</div>
                    <div className="footer-info__wrapper">
                        <a href={`tel:${process.env.REACT_APP_TEL}`} className="footer-info__number">
                            <div className={`number-${lang}`}>02-712-7272</div>
                        </a>
                        <a href={`mailto:${process.env.REACT_APP_EMAIL}`} className="footer-info__email">
                            <div className={`email-${lang}`}>info@sprinkle-th.com</div>
                        </a>
                        <a href={process.env.REACT_APP_LINE} className="footer-info__line">
                            <div className={`line-${lang}`}>@sprinklewater</div>
                        </a>
                    </div>
                </div>
                <div className="footer-copywriter">&#169; {lang === 'en' ? en.copyrightsLabel : th.copyrightsLabel}</div>
            </footer>
        </Container>
    )
}